import { z } from 'zod';

import { optionalEnum } from '../../../utils.js';
import { ApiInstanceFhirMethod } from '../../orchestrator/apiInstanceFhir.js';
import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';
import { BlockValueUuidSchema } from '../base/blockValueUuidSchema.js';
import { RequestBodyFormat, ResponseBodyFormat } from '../rest/config.js';

export enum EndpointType {
  Search = 'Search',
  Custom = 'Custom',
}

export const AdvancedFhirBlockConfigSchema = z.object({
  apiInstanceId: BlockValueUuidSchema({ isRequired: true }),
  path: z.string().refine((path) => path.startsWith('/'), {
    message: 'Path must start with /',
  }),
  selectedResponseHeaders: z.array(z.string()).optional(),
  method: z.enum(ApiInstanceFhirMethod),
  headers: z
    .array(
      z.object({
        key: z.string().min(1, {
          message: 'Header key cannot be empty.',
        }),
        value: z.string().min(1, {
          message: 'Header value cannot be empty.',
        }),
      })
    )
    .optional(),
  params: z
    .array(
      z.object({
        key: z.string().min(1, {
          message: 'Parameter key cannot be empty.',
        }),
        value: z.string().min(1, {
          message: 'Parameter value cannot be empty.',
        }),
      })
    )
    .optional(),
  bodyFormat: optionalEnum(RequestBodyFormat, RequestBodyFormat.RawJson),
  responseBodyFormat: optionalEnum(ResponseBodyFormat, ResponseBodyFormat.AutoDetect),
  body: z.string().optional(),
  apiInstanceFhirEndpointId: z.string().optional(),
});

export const AdvancedFhirBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.AdvancedFhir),
  config: AdvancedFhirBlockConfigSchema,
});

export type AdvancedFhirBlock = z.infer<typeof AdvancedFhirBlockSchema>;
